module.exports = __webpack_public_path__ + "static/ideation-product-strategy-mobile-e3cc347cdc546d272c57446b1b3b2867.jpg";